import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import colors from "../Constant/colors";

const PromotionManagement = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardStyle = {
    background: "#ffffff",
    padding: "20px",
    borderRadius: "14px",
    boxShadow: `0 4px 12px ${colors.cardShadow}`,
    display: "flex",
    alignItems: "center",
    gap: "12px",
    minHeight: "100px",
    transition: "0.3s",
  };

  const heading = {
    fontSize: "18px",
    fontWeight: "600",
    color: colors.grayDark,
  };

  const subText = {
    fontSize: "12px",
    color: colors.grayDark,
    opacity: 0.85,
    marginTop: "2px",
  };

  const iconStyle = {
    fontSize: "32px",
    minWidth: "40px",
  };

  const titleStyle = {
    fontWeight: "700",
    color: colors.grayDark,
  };

  return (
    <div
      style={{ background: "#ffffff", minHeight: "100vh" }}
      className="flex justify-center items-start p-6"
    >
      <div className="w-full max-w-7xl">
        {/* Header */}
        

        {/* Grid */}
        <div
          className={`grid gap-6 ${isMobile ? "grid-cols-1" : "grid-cols-3"}`}
          style={{ alignItems: "stretch" }}
        >
          {/* Add Session */}
          <Link to="/add-session" className="flex">
            <div style={cardStyle} className="hover:scale-[1.02] w-full">
              <i
                className="fas fa-plus-circle"
                style={{ ...iconStyle, color: "#39FF14" }}
              ></i>
              <div>
                <h2 style={heading}>Add Session</h2>
                <p style={subText}>Create and manage new sessions.</p>
              </div>
            </div>
          </Link>

          {/* Promote Session */}
          <Link to="/promote-session" className="flex">
            <div style={cardStyle} className="hover:scale-[1.02] w-full">
              <i
                className="fas fa-arrow-up"
                style={{ ...iconStyle, color: "#EF4444" }}
              ></i>
              <div>
                <h2 style={heading}>Promote Session</h2>
                <p style={subText}>Promote existing sessions to higher levels.</p>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PromotionManagement;
